import EmbeddableCheckbox from "@components/C138_EmbeddableForm/EmbeddableCheckbox";

export default function SmsConsent({
  showSMSConsent,
  field,
  index,
  smsConsentText,
  isSMSconsentChecked,
  smsConsentGiven,
  setIsSMSconsentChecked,
  register,
}) {
  if (!showSMSConsent) return null;
  if (smsConsentGiven) return null;

  return (
    <div className="form-row">
      <div className="form-field base6">
        <EmbeddableCheckbox
          id="canContactBySms"
          key={`${field.labelText}${index}`}
          name="canContactBySms"
          value={smsConsentText}
          checked={isSMSconsentChecked}
          label={smsConsentText}
          {...register("canContactBySms")}
          onChange={() => setIsSMSconsentChecked(!isSMSconsentChecked)}
        />
      </div>
    </div>
  );
}
